/**
 * The four result bands a single fixture's points fall into. Named after the visual treatment
 * they drive rather than the scoring rule, because two surfaces render them differently from the
 * same answer: the game cards in another player's "GW N Calls" reveal and the
 * profile's Best-gameweek mark row.
 */
export type GameTier = 'win' | 'blue' | 'muted' | 'zero'

/** 5 = exact score, 3 = correct outcome, 1-2 = a goal count right, 0 = missed. */
export function tierForPoints(points: number): GameTier {
  if (points >= 5) return 'win'
  if (points >= 3) return 'blue'
  if (points >= 1) return 'muted'
  return 'zero'
}
